module.exports = __webpack_public_path__ + "img/yxkpro_ios.6855e3c8.png";